import config from '../config';

const researchActivityLabels = toLabels(config.researchActivities);
const healthCategoryLabels = toLabels(config.healthCategories);

export default (rows) => {
    return rows.map(row => {
        const out = {};
        Object.keys(row.other).forEach(key => {
           out[key] = row.other[key];
        });
        addToRow(row.researchActivities[0], 'RESEARCH_ACTIVITY_1', researchActivityLabels, out);
        addToRow(row.researchActivities[1], 'RESEARCH_ACTIVITY_2', researchActivityLabels, out);
        addToRow(row.healthCategories[0], 'HEALTH_CATEGORY_1', healthCategoryLabels, out);
        addToRow(row.healthCategories[1], 'HEALTH_CATEGORY_2', healthCategoryLabels, out);
        addToRow(row.healthCategories[2], 'HEALTH_CATEGORY_3', healthCategoryLabels, out);
        addToRow(row.healthCategories[3], 'HEALTH_CATEGORY_4', healthCategoryLabels, out);
        addToRow(row.healthCategories[4], 'HEALTH_CATEGORY_5', healthCategoryLabels, out);
        return out;
    });
}

function addToRow(activity, keyPrefix, labels, out) {
    const isProvided = activity && activity.value !== 0;
    out[config.spreadsheet[keyPrefix]] = isProvided ? activity.value : '';
    out[config.spreadsheet[keyPrefix + '_DESCRIPTION']] = isProvided ? (labels.has(activity.value) ? labels.get(activity.value) : '') : '';
    out[config.spreadsheet[keyPrefix + '_PERCENTAGE']] = isProvided ? activity.percentage / 100 : '';
}

function toLabels(entries) {
    const labels = new Map();
    entries.forEach(activity => {
        const matches = /\d+\. (.*)/.exec(activity.label);
        labels.set(activity.value, matches ? matches[1] : activity.label);
    });
    return labels;
}


// WEBPACK FOOTER //
// ./src/HrcsEditor/mapping/exportMapper.js